export default `
    --gray-mask-000:        var(--white-00), var(--trans-gray-000);
    --gray-mask-100:        #f8f9fc00, var(--white-02);
`;
